export default __webpack_public_path__ + "static/media/myjourney-smallgraytree.b6358b66.svg";